import { ListChecks, CreditCard, Mail } from "lucide-react";

const steps = [
  {
    icon: ListChecks,
    title: "Choisissez votre formule",
    description: "Sélectionnez un soin spécifique ou un montant libre",
  },
  {
    icon: CreditCard,
    title: "Paiement sécurisé",
    description: "Réglez en toute sécurité via Stripe, la plateforme de paiement la plus utilisée au monde",
  },
  {
    icon: Mail,
    title: "Recevez instantanément",
    description: "Le bon cadeau arrive par email en quelques secondes",
  },
];

const GiftCardSteps = () => {
  return (
    <section className="bg-gradient-to-b from-bbz-beige/20 to-background py-8 md:py-10">
      <div className="container mx-auto px-4">
        <h2 className="text-center font-playfair text-3xl md:text-4xl font-semibold text-bbz-text mb-3">
          Comment ça marche ?
        </h2>
        <p className="text-center text-muted-foreground mb-8 max-w-2xl mx-auto">
          Offrir une carte cadeau bien-être n'a jamais été aussi simple
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 max-w-4xl mx-auto">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center"
              >
                {/* Icône principale */}
                <div className="w-20 h-20 rounded-full bg-primary/40 flex items-center justify-center mb-4 shadow-md border border-primary/20">
                  <Icon className="w-10 h-10 text-primary" strokeWidth={2.5} />
                </div>
                
                {/* Titre */}
                <h3 className="font-playfair text-xl font-semibold mb-3">
                  {step.title}
                </h3>
                
                {/* Description */}
                <p className="text-sm text-muted-foreground max-w-xs">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GiftCardSteps;
